<template>
  <component-wrapper>
    <div class="retailer-search-page-fi">
      <grid-container-fi>
        <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-4 lg:fi-col-end-10">
          <!-- eslint-disable vue/no-v-html -->
          <h1
            v-if="isEditMode"
            class="retailer-search-page-fi__headline"
            v-html="fields.retailerSearchHeadline.editable"
          />
          <h1
            v-else
            class="retailer-search-page-fi__headline"
            v-html="fields.retailerSearchHeadline?.value"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </grid-container-fi>

      <grid-container-fi :container="isSM">
        <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
          <retailer-search-fi
            :fields="fields"
            :country-list="countryList[1]"
            :default-country="countryList[2]"
            :ranges="ranges"
            :default-range="defaultRange"
            retailer-search-page
          />
        </div>
      </grid-container-fi>
    </div>
  </component-wrapper>
</template>

<script>
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import breakpointMixin from 'mixins/breakpointMixin';
import distanceMixin from 'mixins/distanceMixin';
import { defineAsyncComponent } from 'vue';

import { getSelectList } from '@/utils/fieldTransformations';

const RetailerSearchFi = defineAsyncComponent(
  () => import('components/retailer-search-fi/RetailerSearchFi'),
);

export default {
  name: 'RetailerSearchPageFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    RetailerSearchFi,
  },
  mixins: [breakpointMixin, distanceMixin],
  inject: ['fields'],
  computed: {
    countryList() {
      return getSelectList(this.fields, 'countryList', []);
    },
    ranges() {
      const ranges = [];
      if (this.fields.retailerSearchRanges?.value) {
        this.fields.retailerSearchRanges.value.split(',').forEach((range) => {
          ranges.push({ name: `${range} ${this.unit}`, value: range });
        });
      }

      return ranges.length ? ranges : undefined;
    },
    defaultRange() {
      if (this.fields.retailerSearchDefaultRange?.value) {
        return this.fields.retailerSearchDefaultRange.value;
      }

      return undefined;
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-search-page-fi';
</style>
